<template>
	<div class="bg-h">
		<div class="w">
			<div>
				<!-- 顶栏容器 -->
				<div class="HeadbodyMain">
					<div class="logo">
						<router-link to="/">
							<img :src="getLogoConfig.logoImg || defaultTitle" alt style="vertical-align: middle" />
						</router-link>
					</div>
					<!-- 全局搜索样式i -->
					<template v-if="headertype == '1'"> </template>
					<AppHeader_Navs style="width: 100%"></AppHeader_Navs>
				</div>
				<!-- 顶栏容器END -->
				<!-- 头部tab -->
				<el-header style="background-color: transparent">
					<el-menu
						:default-active="activeIndex"
						mode="horizontal"
						active-text-color="#fff"
						router
						@select="handleSelect"
						style="background-color: transparent; display: flex; justify-content: space-between"
					>
						<el-menu-item index="/">{{ $t('system.headerMenu.HomePage') }}</el-menu-item>
						<el-submenu index="/mall/moonDATA">
							<template slot="title">{{ $t('system.headerMenu.ScientificData') }}</template>
							<!-- <el-menu-item :index="item.name == '月球' ? '/mall/moonDATA' : '/mall/MarsDATA'" v-for="(item, index) in dataType" :key="index">{{ item.name }}</el-menu-item> -->
							<el-menu-item index="/mall/moonDATA">{{ $t('system.headerMenu.Moon') }}</el-menu-item>
							<el-menu-item index="/mall/MarsDATA">{{ $t('system.headerMenu.Planet') }}</el-menu-item>
						</el-submenu>
						<!-- <el-menu-item index="/PDSINDEX">PDS卷集</el-menu-item> -->
						<el-submenu index="/PDSINDEX">
							<template slot="title">{{ $t('system.headerMenu.PDSDataSet') }}</template>
							<el-menu-item index="/PDSINDEX">{{ $t('system.headerMenu.Moon') }}</el-menu-item>
							<el-menu-item>{{ $t('system.headerMenu.Mars') }}</el-menu-item>
						</el-submenu>
						<el-submenu index="/WebGIS">
							<template slot="title">WebGIS</template>
							<el-menu-item @click="openNewTab('https://moon.bao.ac.cn/Moon/plviewer/moon.html')">{{ $t('system.headerMenu.Moon') }}</el-menu-item>
							<el-menu-item @click="openNewTab('https://moon.bao.ac.cn/Mars/plviewer/mars.html')">{{ $t('system.headerMenu.Mars') }}</el-menu-item>
						</el-submenu>

						<el-menu-item @click="openNewTab('https://lpnd.bao.ac.cn/#/')">{{ $t('system.headerMenu.LunarSample') }}</el-menu-item>
						<el-submenu index="/">
							<template slot="title">{{ $t('system.headerMenu.extraterrestrial') }}</template>
							<el-menu-item index="/moonSampleHome">{{ $t('system.headerMenu.SampleMoon') }}</el-menu-item>
							<el-menu-item>{{ $t('system.headerMenu.SampleAsteroid') }}</el-menu-item>
						</el-submenu>
						<el-menu-item index="/remoteSensingpedia">{{ $t('system.headerMenu.PopularScience') }}</el-menu-item>
						<el-menu-item index="/ResourceTools">{{ $t('system.headerMenu.ResourceTools') }}</el-menu-item>
						<el-menu-item index="/aboutUS">{{ $t('system.headerMenu.AboutUs') }}</el-menu-item>
					</el-menu>
				</el-header>
			</div>
			<!-- 头部tab END -->

			<!-- <div class="guoji" @click="toguoji"><span style="font-size: 14px; color: #ffffff;">进入国际版</span></div> -->
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
import AppHeader_Navs from './AppHeader_Navs.vue'
export default {
	components: { AppHeader_Navs },
	props: {
		type: String
	},
	data() {
		return {
			activeIndex: 1,
			dataType: [],
			defaultTitle: require('@/assets/imgs/newHome/位图.png'),
			searchMessage: '',
			headertype: '1' //默认为1 控制搜索不同功能样式
		}
	},
	computed: {
		...mapGetters(['getActive', 'getLogoConfig', 'getPlatformName'])
	},
	watch: {
		type: {
			immediate: true,
			handler(newName, oldName) {
				this.headertype = newName
			}
		},
		// 获取vuex的tab选中状态
		getActive: function (val) {
			// console.log('获取vuex的tab选中状态', val)
		}
	},
	mounted() {
		console.log(window.location)
		this.getDataTypeFunc()
	},
	methods: {
		handleSelect(key, keyPath) {
			localStorage.removeItem('tempObj')
			console.log(key, keyPath)
			// if(key.name == '月球'){
			//   this.$router.replace({ path: '/mall/MarsDATA'});
			// }
		},
		async getDataTypeFunc() {
			let res = await this.$http.get(this.$const.Platformconsulting.getDataType)
			if (res && res.code == 200) {
				this.dataType = res.data
			}
			if (window.location.hash == '#/remoteSensingpedia') {
				this.activeIndex = '/remoteSensingpedia'
			}
		},
		openNewTab(url) {
			window.open(url, '_blank')
		},
		toguoji() {
			const url = '/toguoji.png'
			window.open(url, '_blank')

			// const newTab = window.open();
			// newTab.document.body.innerHTML = `<img src="${url}" style="width: 100%; height: 100%; object-fit: contain;">`;

			// newTab.document.write('<html><head><title>新标签页</title></head><body></body></html>');
			// newTab.document.body.innerHTML = '<h1>Hello World!</h1>';
		},

		// ...mapActions(["setActive"]),
		async reSearchload() {
			console.log('搜索触发！')
			if (this.searchMessage != '') {
				// 跳转到搜索页面,并传递搜索条件
				console.log(this.searchMessage)
				this.$router.push({
					path: 'search',
					query: { search: this.searchMessage }
				})
				this.searchMessage = ''
			} else {
				this.$router.push({
					name: 'search',
					params: {},
					query: {}
				})
			}
		},
		reSearchloadYX() {
			// if (this.searchMessage != "") {
			//   // 跳转到搜索页面,并传递搜索条件
			//   this.$router.push({ path: "/productSearch", query: { search: this.searchMessage } });
			//   this.searchMessage = "";
			// }
			// 跳转到搜索页面,并传递搜索条件
			let routeData = this.$router.resolve({
				path: '/productSearch',
				query: {
					search: this.searchMessage ? this.searchMessage : ''
				}
			})

			window.open(routeData.href, '_blank')
			// this.$router.push({ path: "/productSearch", query: { search: this.searchMessage ? this.searchMessage : '' } });
			this.searchMessage = ''
		}
	}
}
</script>

<style>
.el-menu--horizontal > .el-menu,
.el-menu--horizontal > .el-menu {
	width: unset !important;
	min-width: 120px !important;
}
</style>
<style lang="scss" scoped>
.bg-h {
	background-image: url('~@/assets/imgs/newHome/bg.png');
	/* 替换为你的背景图URL */
	background-size: cover;
	/* 背景图按容器比例缩放，保证图片覆盖整个容器 */
	background-repeat: no-repeat;
	/* 背景图不重复 */
	background-position: center;
	/* 背景图居中显示 */
}
.guoji {
	height: 41px;
	line-height: 41px;
	cursor: pointer;
	width: 110px;
	text-align: center;
	background: #2469f1;
	position: absolute;
	top: 52px;
	right: 50px;
}

/* 顶栏容器CSS */
.HeadbodyMain {
	padding-top: 40px;
	width: 100%;
	display: flex;

	.logo {
		display: flex;
		line-height: 10vh;
		align-items: center;
		flex: 1;
	}

	.logoText {
		font-size: 36px;
		font-weight: 700;
		color: #1b143c;
		letter-spacing: 1.44px;
		// padding-left: 15px;
		cursor: pointer;
	}

	.so {
		width: 250px;
	}

	.search-frame {
		width: 350px;
		height: 41px;
		display: flex;
		position: relative;
		// border-radius: 4px;
		/* box-sizing: border-box; */
		margin: 50px auto 0;
		border: 2px solid #2469f1;
		border-right: 3px;
	}

	.searchTip {
		position: absolute;
		left: -2px;
		z-index: 999;
		top: 42px;
		width: calc(100% + 4px);
		height: auto;
		padding: 0;
		box-sizing: border-box;
		line-height: 40px;
		background: #edf2f7;
		font-size: 14px;
		color: #757575;
		/* border-left: 2px solid #2469f1;
border-right: 2px solid #2469f1;
border-bottom: 2px solid #2469f1; */
	}

	.searchTip li {
		cursor: pointer;
		text-indent: 10px;
		overflow: hidden;
		/*超出部分隐藏*/
		text-overflow: ellipsis;
		/* 超出部分显示省略号 */
		white-space: nowrap;
		/*规定段落中的文本不进行换行 */
	}

	.searchTip li:hover {
		background: #ebebeb;
		color: #2469f1;
	}

	.search-frame-input {
		width: 90%;
		padding-left: 15px;
		border: 0;
		outline: none;
	}

	.search-frame-btn {
		cursor: pointer;
		width: 110px;
		text-align: center;
		line-height: 34px;
		background: #2469f1;
		z-index: 6;
	}

	.search-frame-input:focus {
		border: 1px solid #2469f1;
	}

	.me-search-article-item {
		margin-left: auto;
		margin-right: auto;
		width: 90%;
	}

	.search-condition {
		font-size: 16px;
		font-weight: 400;
		// color: #333333;
		color: #fff;
		line-height: 25px;
		cursor: pointer;
		padding-left: 12px;
		padding-right: 12px;
		margin-right: 25px;
	}

	.search-condition:hover {
		background: linear-gradient(92deg, #735dc4, #619ff9 81%, #2469f1);
		border-radius: 13px;
		color: #fff;
		height: 25px;
		display: inline-block;
	}
}

/* 顶栏容器CSS END */
.el-menu--horizontal {
	border-bottom: 0px;

	// .element-with-bottom-image {
	// 		position: relative;
	// 		/* 确保伪元素能够相对于此元素定位 */
	// 		display: inline-block;
	// 		/* 或其他适当的显示类型 */
	// 		/* 其他样式 */
	// 	}

	// 	.element-with-bottom-image::after {
	// 		content: "";
	// 		/* 伪元素需要内容才能生成盒子模型，但这里我们不需要实际的内容 */
	// 		position: absolute;
	// 		/* 绝对定位相对于最近的已定位祖先元素（在这里是 .element-with-bottom-image） */
	// 		left: 0;
	// 		/* 设置左边界 */
	// 		bottom: 0;
	// 		/* 设置底边界 */
	// 		width: 100%;
	// 		/* 宽度与父元素相同 */
	// 		height: 30px;
	// 		/* 高度根据需要调整，这里假设图片高度为30px */
	// 		background-image: url('your-image-url.png');
	// 		/* 替换为你的图片URL */
	// 		background-size: contain;
	// 		/* 根据需要调整图片大小，这里使用contain保持图片比例 */
	// 		background-repeat: no-repeat;
	// 		/* 防止图片重复 */
	// 		background-position: center;
	// 		/* 图片居中显示 */
	// 	}

	> .el-menu-item {
		font-size: 18px;

		color: #fff;
		opacity: 0.5;
		// min-width: 132px;
		text-align: center;

		&.is-active {
			opacity: 1;
			border-bottom: none;
			background: transparent;
			// border-bottom: 3px solid #2469f1 !important;
			// font-weight: 700;
			color: #fff !important;
			position: relative;
			display: inline-block;
		}

		&.is-active::after {
			content: '';
			/* 伪元素需要内容才能生成盒子模型，但这里我们不需要实际的内容 */
			position: absolute;
			/* 绝对定位相对于最近的已定位祖先元素（在这里是 .element-with-bottom-image） */
			left: 0;
			/* 设置左边界 */
			bottom: 0;
			/* 设置底边界 */
			width: 100%;
			/* 宽度与父元素相同 */
			height: 30px;
			/* 高度根据需要调整，这里假设图片高度为30px */
			background-image: url('~@/assets/imgs/newHome/bg4.png');
			/* 替换为你的图片URL */
			background-size: contain;
			/* 根据需要调整图片大小，这里使用contain保持图片比例 */
			background-repeat: no-repeat;
			/* 防止图片重复 */
			background-position: bottom;
			/* 图片居中显示 */
		}

		&:not(.is-disabled):focus,
		&:not(.is-disabled):hover {
			background: transparent;
			color: #fff !important;
			// border-bottom: 3px solid #2469f1 !important;
			// font-weight: 700;
		}
	}
}

> ::v-deep .el-submenu {
	// width: 120px !important;

	&.is-active {
		> .el-submenu__title {
			// opacity: 0.5;
			// border-bottom: 3px solid #2469f1 !important;
			// font-weight: 700;
			color: #fff !important;
		}
	}

	> .el-submenu__title {
		font-size: 18px;
		color: #fff;
		opacity: 0.5;

		&:hover {
			background: transparent;
			color: #fff;
			// font-weight: 700;
			// border-bottom: 3px solid #2469f1 !important;
		}
	}

	> .el-submenu__title {
		> i {
			display: none;
		}
	}
}

.el-menu-item:not(.is-disabled):hover {
	background-color: rgba(37, 105, 242, 0.15) !important;
	color: #2569f2 !important;
}
.el-menu--horizontal .el-menu .el-menu-item.is-active {
	color: #1b143c !important;
}
</style>

<style>
.el-menu--horizontal > .el-submenu:focus .el-submenu__title,
.el-menu--horizontal > .el-submenu:hover .el-submenu__title {
	color: #fff !important;
}
</style>